import BananaWithPointer from '@buncha/components/core/icon/BananaWithPointer';
import {Box} from '../../../components/core/view';
import {Components} from '@buncha/localization/types';
import {Modules} from '@buncha/utils/types';
import React from 'react';
import {StyleSheet} from 'react-native';
import {useGetLocale} from '@buncha/localization/hooks';

import {CustomText, H6Text} from '../../../components/core/text';
import {
  useColorThemeType,
  useFontTheme,
} from '../../../../src/appStyles/hooks/theme';

interface NewFeatureBannerProps {
  title: string;
}

const NewFeatureBanner: React.FC<NewFeatureBannerProps> = props => {
  const theme = useColorThemeType('main');
  const muli = useFontTheme('muli');
  const title = props?.title || '';
  const {body} = useGetLocale(Modules.common, Components.components) ?? {};
  return (
    <Box
      style={[styles.headerBox, {borderColor: theme?.background?.yellow[100]}]}>
      <Box style={styles.imageBox}>
        <BananaWithPointer viewBox="5 0 25 35" height={50} width={50} />
      </Box>
      <Box style={styles.textBox}>
        <H6Text
          style={[
            styles.text,
            {
              color: theme?.text?.blue[300],
              fontFamily: muli?.[700]?.normal,
            },
          ]}>
          {title}
        </H6Text>
      </Box>
      <CustomText
        style={[
          styles.newFeatureText,
          {
            backgroundColor: theme?.background?.yellow[100],
            color: theme?.text?.blue[300],
            fontFamily: muli?.[700]?.normal,
          },
        ]}>
        {body?.newFeature}
      </CustomText>
    </Box>
  );
};

export default React.memo(NewFeatureBanner);
const styles = StyleSheet.create({
  headerBox: {
    flexDirection: 'row',
    width: '100%',
    borderWidth: 2,
    borderTopRightRadius: 0,
    borderRadius: 5,
    paddingVertical: 8,
    paddingHorizontal: 8,
    marginVertical: 5,
    position: 'relative',
  },
  textBox: {
    paddingHorizontal: 5,
    flex: 1,
  },
  text: {
    textAlign: 'left',
  },
  image: {
    height: 30,
    width: 30,
  },
  imageBox: {
    justifyContent: 'center',
    marginHorizontal: 5,
  },
  newFeatureText: {
    position: 'absolute',
    top: -22,
    right: -2,
    paddingHorizontal: 10,
    paddingVertical: 3,
    borderRadius: 5,
    overflow: 'hidden',
  },
});
